import { fieldTypes, TABS } from "@icarius-utils/constants";

const NAME = "PERSONAL_DATA_PAGE";

export const myPersonalDataFields = [
    {
        name: "CODIGO DE EMPLEADO",
        readOnlyType: fieldTypes.text,
        label: "employeeCode",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "ESTADO",
        readOnlyType: fieldTypes.text,
        label: "state",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "APELLIDO PATERNO",
        readOnlyType: fieldTypes.text,
        label: "fatherLastName",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "APELLIDO MATERNO",
        readOnlyType: fieldTypes.text,
        label: "motherLastName",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "PRIMER NOMBRE",
        readOnlyType: fieldTypes.text,
        label: "firstName",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "SEGUNDO NOMBRE",
        readOnlyType: fieldTypes.text,
        label: "secondName",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "SEXO",
        readOnlyType: fieldTypes.text,
        label: "sex",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "ESTADO CIVIL",
        readOnlyType: fieldTypes.text,
        label: "civilState",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "FECHA DE NACIMIENTO",
        readOnlyType: fieldTypes.text,
        label: "bornDate",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "NACIONALIDAD",
        readOnlyType: fieldTypes.text,
        label: "nationality",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "EMAIL",
        readOnlyType: fieldTypes.email,
        label: "email",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "EMAIL PERSONAL",
        readOnlyType: fieldTypes.email,
        label: "personalEmail",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "CELULAR",
        readOnlyType: fieldTypes.phone,
        label: "cellphone",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "LINKEDIN",
        readOnlyType: fieldTypes.text,
        label: "linkedin",
        tab: TABS.personal,
        column: 0,
    },
    {
        name: "DIRECCION",
        readOnlyType: fieldTypes.address,
        label: "address",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "PAIS",
        readOnlyType: fieldTypes.text,
        label: "country",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "REGION",
        readOnlyType: fieldTypes.text,
        label: "region",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "PROVINCIA",
        readOnlyType: fieldTypes.text,
        label: "provicia",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "COMUNA",
        readOnlyType: fieldTypes.text,
        label: "comuna",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "GRUPO SANGUINEO",
        readOnlyType: fieldTypes.text,
        label: "bloodType",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "DONANTE",
        readOnlyType: fieldTypes.text,
        label: "donante",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "NRO DE PASAPORTE",
        readOnlyType: fieldTypes.text,
        label: "passportNumber",
        tab: TABS.personal,
        column: 1,
    },
    {
        name: "EXPIRACION DEL PASAPORTE",
        readOnlyType: fieldTypes.text,
        label: "expirationPassport",
        tab: TABS.personal,
        column: 1,
    },
    /////////Contractuales 
    {
        name: "TIPO DE FUNCIONARIO",
        readOnlyType: fieldTypes.text,
        label: "fType",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "TIPO DE CONTRATO",
        readOnlyType: fieldTypes.text,
        label: "contractType",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "CODIGO DE CONTRATO",
        readOnlyType: fieldTypes.text,
        label: "contractCode",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "TIPO DE CONTRATACION",
        readOnlyType: fieldTypes.text,
        label: "contratacionType",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "CANTIDAD DE CONTRATACIONES",
        readOnlyType: fieldTypes.text,
        label: "contractAmount",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "TIPO DE JORNADA",
        readOnlyType: fieldTypes.text,
        label: "jornadaType",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "HORAS DIARIAS CONTRATO",
        readOnlyType: fieldTypes.number,
        label: "hoursPerDay",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "HORAS SEMANALES CONTRATO",
        readOnlyType: fieldTypes.number,
        label: "weeklyHoursContract",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "HORAS MENSUALES CONTRATO",
        readOnlyType: fieldTypes.number,
        label: "hoursPerMonth",
        tab: TABS.contract,
        column: 0,
    },
    {
        name: "CONTRATISTA",
        readOnlyType: fieldTypes.text,
        label: "contratista",
        tab: TABS.contract,
        column: 1,
    },
    {
        name: "OBRA O FAENA",
        readOnlyType: fieldTypes.text,
        label: "workOrJob",
        tab: TABS.contract,
        column: 1,
    },
    {
        name: "FECHA DE ANTIGUEDAD",
        readOnlyType: fieldTypes.text,
        label: "antiquityDate",
        tab: TABS.contract,
        column: 1,
    },
    {
        name: "FECHA DE INGRESO",
        readOnlyType: fieldTypes.text,
        label: "incomeDate",
        tab: TABS.contract,
        column: 1,
    },
    //Remunerativos
    {
        name: "UNIDAD SALARIAL",
        readOnlyType: fieldTypes.text,
        label: "salaryUnit",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "SUELDO BASICO",
        readOnlyType: fieldTypes.number,
        label: "salary",
        decimals: 2,

        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "MONEDA",
        readOnlyType: fieldTypes.text,
        label: "coin",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "FORMA DE PAGO",
        readOnlyType: fieldTypes.text,
        label: "paymentMethod",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "BANCO",
        readOnlyType: fieldTypes.text,
        label: "bank",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "CUENTA BANCARIA",
        readOnlyType: fieldTypes.text,
        label: "bankAccount",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "TIPO DE CUENTA BANCARIA",
        readOnlyType: fieldTypes.text,
        label: "bankAccountType",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "JUBILADO",
        readOnlyType: fieldTypes.text,
        label: "retired",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "TIPO DE TRABAJADOR",
        readOnlyType: fieldTypes.text,
        label: "SHOW_WORKER_TYPE",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "TRAMO DE ASIGNACION FAMILIAR",
        readOnlyType: fieldTypes.text,
        label: "familyAllowanceSection",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "REBAJA ZONA EXTREMA",
        readOnlyType: fieldTypes.text,
        label: "extremeZoneReduction",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "PORCENTAJE ZONA EXTREMA",
        readOnlyType: fieldTypes.text,
        label: "extremeZonePercentage",
        tab: TABS.remuneration,
        column: 0,
    },
    {
        name: "INSTITUCION DE PREVISION",
        readOnlyType: fieldTypes.text,
        label: "previsionInstitution",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "FECHA AFILIACION PREVISIONAL",
        readOnlyType: fieldTypes.text,
        label: "affiliationDate",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "INSTITUCION DE SALUD",
        readOnlyType: fieldTypes.text,
        label: "healthInstitution",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "SINDICATO",
        readOnlyType: fieldTypes.text,
        label: "laborUnion",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "SUELDO EMPRESARIAL",
        readOnlyType: fieldTypes.text,
        label: "businessSalary",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "TRABAJO PESADO",
        readOnlyType: fieldTypes.text,
        label: "heavyWork",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "IMPONE EN OTRO PAIS",
        readOnlyType: fieldTypes.text,
        label: "taxOtherCountry",
        tab: TABS.remuneration,
        column: 1,
    },
    {
        name: "VALOR COTIZADO EN OTRO PAIS",
        readOnlyType: fieldTypes.text,
        label: "valueOtherCountry",
        tab: TABS.remuneration,
        column: 1,
    },
    //Ubicacion  
    {
        name: "GERENCIA",
        readOnlyType: fieldTypes.text,
        label: "management",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "DEPARTAMENTO",
        readOnlyType: fieldTypes.text,
        label: "department",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "SECCION",
        readOnlyType: fieldTypes.text,
        label: "section",
        tab: TABS.location,
        column: 0,
    },
    //

    {
        name: "LUGAR DE TRABAJO",
        readOnlyType: fieldTypes.text,
        label: "jobLocation",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "FECHA ASIGNACION LUGAR DE TRABAJO",
        readOnlyType: fieldTypes.text,
        label: "workLocationAssignmentDate",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "DIVISION",
        readOnlyType: fieldTypes.text,
        label: "SHOW_DIVISION",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "FECHA ASIGNACION DIVISION",
        readOnlyType: fieldTypes.text,
        label: "unitAssignationDate",
        tab: TABS.location,
        column: 0,
    },
    {
        name: "MODALIDAD DE TRABAJO",
        readOnlyType: fieldTypes.text,
        label: 'workMode',
        tab: TABS.location,
        column: 0,
    },
    {
        name: "CARGO",
        readOnlyType: fieldTypes.text,
        label: "position",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "FECHA ASIGNACION CARGO",
        readOnlyType: fieldTypes.text,
        label: "positionDate",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "FUNCION",
        readOnlyType: fieldTypes.text,
        label: "function",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "FECHA ASIGNACION FUNCION",
        readOnlyType: fieldTypes.text,
        label: "functionDate",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "CENTRO DE COSTO",
        readOnlyType: fieldTypes.text,
        label: "costCenter",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "FECHA ASIGNACION CENTRO DE COSTO",
        readOnlyType: fieldTypes.text,
        label: "costCenterAssignmentDate",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "CATEGORIA",
        readOnlyType: fieldTypes.text,
        label: "category",
        tab: TABS.location,
        column: 1,
    },
    {
        name: "ESPECIALIDAD",
        readOnlyType: fieldTypes.text,
        label: "specialty",
        tab: TABS.location,
        column: 1,
    },

    ////TIEMPO
    {
        name: "TURNO",
        readOnlyType: fieldTypes.text,
        label: "shift",
        tab: TABS.time,
        column: 0,
    },
    {
        name: "FECHA ASIGNACION TURNO",
        readOnlyType: fieldTypes.text,
        label: "shiftDate",
        tab: TABS.time,
        column: 0,
    },
    {
        name: "TIPO DE CALENDARIO",
        readOnlyType: fieldTypes.text,
        label: "calendarType",
        tab: TABS.time,
        column: 0,
    },
    {
        name: "TIPO DE CONTROL HORARIO",
        readOnlyType: fieldTypes.text,
        label: "scheduleControlType",
        tab: TABS.time,
        column: 0,
    },
    {
        name: "HORARIO",
        readOnlyType: fieldTypes.text,
        label: "scheduleProgrammed",
        tab: TABS.time,
        column: 0,
    },
    //
    {
        name: "CLASIFICACION INE",
        readOnlyType: fieldTypes.text,
        label: "ineClassif",
        tab: TABS.specialClassification,
        column: 0,
    },
    {
        name: "CAPACIDADES ESPECIALES",
        readOnlyType: fieldTypes.text,
        label: "specialCapabilities",
        tab: TABS.specialClassification,
        column: 0,
    },
    {
        name: "TIPO DE POLIZA",
        readOnlyType: fieldTypes.text,
        label: "insurancePolicyType",
        tab: TABS.specialClassification,
        column: 0,
    },
    {
        name: "VALOR DE LA PRIMA EN UF",
        readOnlyType: fieldTypes.number,
        label: "insuranceValueUF",
        decimals: 2,
        tab: TABS.specialClassification,
        column: 0,
    },
    {
        name: "NUMERO DE POLIZA",
        readOnlyType: fieldTypes.text,
        label: "insurancePolicyNumber",
        tab: TABS.specialClassification,
        column: 0,
    },
    {
        name: "CODIGO DE JORNADA",
        readOnlyType: fieldTypes.text,
        label: "workShiftCode",
        tab: TABS.specialClassification,
        column: 1,
    },
    {
        name: "SUBSIDIO TRABAJADOR JOVEN",
        readOnlyType: fieldTypes.text,
        label: 'subsidyYoungWorker',
        tab: TABS.specialClassification,
        column: 1,
    },
    {
        name: "INDEMNIZACION A TODO EVENTO",
        readOnlyType: fieldTypes.text,
        label: "indemnityForAllEvents",
        tab: TABS.specialClassification,
        column: 1,
    },
    {
        name: "TASA INDEM",
        readOnlyType: fieldTypes.text,
        label: 'rateAllEvent',
        tab: TABS.specialClassification,
        column: 1,
    },
];

export const CREATE_DEFAULT_VALUES = [
    {
        name: "SEXO",
        value: "M",
    },
    {
        name: "FECHA DE EGRESO",
        value: null,
    },
    {
        name: "MOTIVO TERMINO LEGAL",
        value: "-",
    },
    {
        name: "MOTIVO TERMINO CALCULO",
        value: "-",
    },
    {
        name: "CODIGO DE CONTRATO",
        value: "",
    },
    {
        name: "BANCO",
        value: "-",
    },
    {
        name: "CUENTA BANCARIA",
        value: "",
    },
    {
        name: "TIPO DE CUENTA BANCARIA",
        value: "-",
    },
    {
        name: "JUBILADO",
        value: "N",
    },
    {
        name: "TRAMO DE ASIGNACION FAMILIAR",
        value: "S",
    },
    {
        name: "REBAJA ZONA EXTREMA",
        value: "N",
    },
    {
        name: "PORCENTAJE ZONA EXTREMA",
        value: 0,
    },
    {
        name: "INSTITUCION DE SALUD",
        value: "-",
    },
    {
        name: "FECHA AFILIACION PREVISIONAL",
        value: null,
    },
    {
        name: "SINDICATO",
        value: "-",
    },
    {
        name: "MESES ADICIONAL VACACIONES",
        value: 0,
    },
    {
        name: "DIAS ADICIONALES VACACIONES",
        value: 0,
    },
    {
        name: "FECHA ADICIONAL VACACIONES",
        value: null,
    },
    {
        name: "SUELDO EMPRESARIAL",
        value: "N",
    },
    {
        name: "TRABAJO PESADO",
        value: "-",
    },
    {
        name: "IMPONE EN OTRO PAIS",
        value: "N",
    },
    {
        name: "VALOR COTIZADO EN OTRO PAIS",
        value: 0,
    },
    {
        name: "CODIGO DE TARJETA",
        value: ""
    },
    {
        name: "HORAS EXTRAS LIBERADAS",
        value: "N"
    },
    {
        name: "CAPACIDADES ESPECIALES",
        value: "0"
    },
    {
        name: "MARCAR CON AVISO PROGRAMADO",
        value: "N"
    },
    {
        name: "CLASIFICACION INE",
        value: "-"
    },
    {
        name: "SUBSIDIO TRABAJADOR JOVEN",
        value: "0"
    },
    {
        name: "INDEMNIZACION A TODO EVENTO",
        value: "0"
    },
    {
        name: "TASA INDEM",
        value: 0
    },
    {
        name: "INSTITUCION DE PREVISION",
        value: "-",
    },
    {
        name: "GRUPO SANGUINEO",
        value: "-",
    },
    {
        name: "DONANTE",
        value: "N",
    },
]

export default NAME;